import { formatToIndianNumberSystem } from "../components/NumberFormatter";

const StockTable = ({ stocks, handleSort, sortConfig, setSelectedStock }) => {
  const getDisplayValue = (value) => (value == null ? 0 : value);

  return (
    <div className="w-[97vw] overflow-x-auto mx-4 ">
      <table className="table-auto w-full border-collapse border border-gray-300 py-0 mt-0">
        <thead>
          <tr className="bg-gray-200 text-left">
            <TableHeader
              sortKey="Id"
              label="Id"
              handleSort={handleSort}
              sortConfig={sortConfig}
            />
            <TableHeader
              sortKey="Symbol"
              label="Symbol"
              handleSort={handleSort}
              sortConfig={sortConfig}
            />
            <TableHeader
              sortKey="Company"
              label="Company"
              handleSort={handleSort}
              sortConfig={sortConfig}
            />

            <TableHeader
              sortKey="AnalysisStatus"
              label="Analysis Status"
              handleSort={handleSort}
              sortConfig={sortConfig}
            />

            <TableHeader
              sortKey="AnalyzedOn"
              label="Analyzed On"
              handleSort={handleSort}
              sortConfig={sortConfig}
            />

            <TableHeader
              sortKey="year"
              label=" Year"
              handleSort={handleSort}
              sortConfig={sortConfig}
            />

            <TableHeader
              sortKey="CurrentPrice"
              label=" Current Price"
              handleSort={handleSort}
              sortConfig={sortConfig}
            />

            <TableHeader
              sortKey="DiscountedValue"
              label="Discounted Value"
              handleSort={handleSort}
              sortConfig={sortConfig}
            />

            <TableHeader
              sortKey="IntrinsicValueUpdatedOn"
              label="Discount Date"
              handleSort={handleSort}
              sortConfig={sortConfig}
            />

            <TableHeader
              sortKey="DividendPotential"
              label="Dividend Potential"
              handleSort={handleSort}
              sortConfig={sortConfig}
            />

            <TableHeader
              sortKey="DividendYield"
              label="Dividend Yield"
              handleSort={handleSort}
              sortConfig={sortConfig}
            />

            <TableHeader
              sortKey="WorkingCaptoPrice"
              label=" WorkingCap to Price"
              handleSort={handleSort}
              sortConfig={sortConfig}
            />

            <TableHeader
              sortKey="PriceToEarnings"
              label="P/E Ratio"
              handleSort={handleSort}
              sortConfig={sortConfig}
            />

            <TableHeader
              sortKey="ProfitMargin"
              label="Margin (%)"
              handleSort={handleSort}
              sortConfig={sortConfig}
            />

            <TableHeader
              sortKey="YearsToClearDebt"
              label="Years to Clear Debt"
              handleSort={handleSort}
              sortConfig={sortConfig}
            />

            <TableHeader
              sortKey="BookValueToPriceRatio"
              label="BV/Price Ratio"
              handleSort={handleSort}
              sortConfig={sortConfig}
            />

            <TableHeader
              sortKey="AssetToDebtRatio"
              label="Asset/Debt Ratio"
              handleSort={handleSort}
              sortConfig={sortConfig}
            />
          </tr>
        </thead>
        <tbody>
          {stocks.length > 0 ? (
            stocks.map((stock, index) => (
              <StockRow
                key={stock.Id}
                stock={stock}
                index={index}
                getDisplayValue={getDisplayValue}
                setSelectedStock={setSelectedStock}
              />
            ))
          ) : (
            <tr>
              <td colSpan="17" className="text-center px-4">
                No data available.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

const TableHeader = ({ sortKey, label, handleSort, sortConfig }) => (
  <th
    className="border border-gray-300 px-1 pr-1 cursor-pointer text-xs "
    onClick={() => handleSort(sortKey)}
  >
    {sortConfig.key === sortKey && (
      <span className="ml-2 text-blue-500">•</span>
    )}
    {label}{" "}
  </th>
);

const StockRow = ({ stock, index, getDisplayValue, setSelectedStock }) => (
  <tr className={index % 2 === 0 ? "bg-white" : "bg-gray-100"}>
    <td className="border border-gray-300 px-1 text-left text-xs">
      {getDisplayValue(stock.Id)}
    </td>
    <td
      className="border border-gray-300 px-2 text-blue-500 cursor-pointer  text-xs"
      onClick={() => setSelectedStock(stock)}
    >
      {getDisplayValue(stock.Symbol)}
    </td>
    <td className="border border-gray-300 px-1 pr-0 text-xs">
      {getDisplayValue(stock.Company)}
    </td>

    <td className="border border-gray-300 px-1 text-right text-xs">
      {getDisplayValue(stock.AnalysisStatus)}
    </td>

    <td className="border border-gray-300 px-1 text-right text-xs">
      {getDisplayValue(stock.AnalyzedOn)}
    </td>

    <td className="border border-gray-300 px-1 text-right text-xs">
      {getDisplayValue(stock.year)}
    </td>

    <td className="border border-gray-300 px-1 text-right text-xs">
      {formatToIndianNumberSystem(getDisplayValue(stock.CurrentPrice).toFixed(2))}
    </td>

    <td className="border border-gray-300 px-1 text-right text-xs">
      {formatToIndianNumberSystem(getDisplayValue(stock.DiscountedValue).toFixed(2))}
    </td>

    <td className="border border-gray-300 px-1 text-right text-xs">
      {getDisplayValue(stock.IntrinsicValueUpdatedOn)}
    </td>

    <td className="border border-gray-300 px-1 text-right text-xs">
      {getDisplayValue(stock.DividendPotential)}
    </td>

    <td className="border border-gray-300 px-1 text-right text-xs">
      {formatToIndianNumberSystem(getDisplayValue(stock.DividendYield).toFixed(2))}
    </td>

    <td className="border border-gray-300 px-1 text-right text-xs">
       {formatToIndianNumberSystem(getDisplayValue(stock.WorkingCaptoPrice).toFixed(2))}
    </td>

    <td className="border border-gray-300 px-1 text-right text-xs">
       {formatToIndianNumberSystem(getDisplayValue(stock.PriceToEarnings).toFixed(2))}
    </td>

    <td className="border border-gray-300 px-1 text-right text-xs">
       {formatToIndianNumberSystem(getDisplayValue(stock.ProfitMargin).toFixed(2))}
    </td>

    <td className="border border-gray-300 px-1 text-right text-xs">
      {formatToIndianNumberSystem(getDisplayValue(stock.YearsToClearDebt).toFixed(2))}
    </td>

    <td className="border border-gray-300 px-1 text-right text-xs">
      {formatToIndianNumberSystem(getDisplayValue(stock.BookValueToPriceRatio).toFixed(2))}
    </td>
    <td className="border border-gray-300 px-1 text-right text-xs">
      {formatToIndianNumberSystem(getDisplayValue(stock.AssetToDebtRatio).toFixed(2))}
    </td>
  </tr>
);

export default StockTable;
